import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { RECORD_TYPES, recordTimeMs, formatRelative } from '../../utils/recordUtils';
import { getPageScale } from '../../utils/pageScale';

const LIMIT = 8;

/** 홈의 '최근 독서 기록' — 모든 책을 가로지르는 시간순 피드 */
const RecentRecordsFeed = ({ records, books }) => {
  const bookById = useMemo(() => {
    const map = new Map();
    books.forEach(book => map.set(book.id, book));
    return map;
  }, [books]);

  const recent = useMemo(
    () => [...records].sort((a, b) => recordTimeMs(b) - recordTimeMs(a)).slice(0, LIMIT),
    [records]
  );

  if (recent.length === 0) {
    return (
      <p className="py-12 text-sm text-ink-600 dark:text-ink-300 font-sans">
        아직 남긴 기록이 없어요
      </p>
    );
  }

  return (
    <ul className="divide-y divide-ink-100 dark:divide-ink-900">
      {recent.map(record => {
        const book = bookById.get(record.bookId);
        const isQuote = record.type === RECORD_TYPES.QUOTE;

        return (
          <li key={record.id}>
            <Link
              to={`/book/${record.bookId}`}
              className="block py-4 transition-opacity hover:opacity-70"
            >
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium truncate font-sans">
                  {book?.title || '삭제된 책'}
                </span>
                <span className="chip !px-1.5 !py-0 !text-[10px] shrink-0">
                  {isQuote ? '인용' : '생각'}
                </span>
                {record.page && (
                  <span className="text-[11px] text-ink-500 dark:text-ink-400 tabular-nums font-sans shrink-0">
                    p.{getPageScale(book).toDisplay(record.page)}
                  </span>
                )}
              </div>
              <p
                className={[
                  'mt-1.5 line-clamp-2 leading-relaxed',
                  isQuote
                    ? 'font-display italic text-ink-800 dark:text-ink-200'
                    : 'text-sm text-ink-700 dark:text-ink-300 font-sans'
                ].join(' ')}
              >
                {record.text}
              </p>
              <p className="mt-1.5 text-[11px] text-ink-500 dark:text-ink-400 font-sans">
                {formatRelative(record.createdAt)}
              </p>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default RecentRecordsFeed;
